// extracted by mini-css-extract-plugin
export default {"wrapper":"text__wrapper__ylumI","title":"text__title__PP5lx","body":"text__body__P6cFe","img":"text__img__iKe1G"};